module.exports = __webpack_public_path__ + "static/progetto_isola101-967aecd5a0401c0e863dc8141e9302ee.jpg";